import { createSelector } from 'reselect';
export const getAuth = state => state.auth;
export const getGates = createSelector([getAuth], auth => auth.gates);
export const createHasGateSelector = gateToCheck => createSelector([getGates], gates => gates.indexOf(gateToCheck) > -1);
export const getIsUngatedForInlineDataTokenEditing = createHasGateSelector('ContentEditorUI:InlineDataTokenEditing');